<template>
	<div class="flex flex-col gap-1">
		<div class="text-xs opacity-80 text-center">Url condivisione</div>
		<n-input-group v-if="shortUrl">
			<n-popover v-if="qrDataUrl" placement="bottom" trigger="click">
				<template #trigger>
					<n-button :size="size">
						<template #icon>
							<n-icon>
								<i-carbon-qr-code />
							</n-icon>
						</template>
					</n-button>
				</template>
				<img :src="qrDataUrl" alt="QR code" class="w-[100px] h-[100px]" />
			</n-popover>
			<n-input
				ref="inputRef"
				:value="tinyShortUrl"
				placeholder="url"
				readonly
				:size="size"
				class="!w-[150px]"
				@click="inputRef.select()"
			/>
			<n-button @click="copy(shortUrl)" :size="size">Copia</n-button>
		</n-input-group>
	</div>
</template>

<script setup>
	import {NInputGroup, NInput, NButton, NPopover, NIcon} from 'naive-ui'
	import ICarbonQrCode from '~icons/carbon/qr-code'
	import {ref, computed} from 'vue'
	import {useClipboard} from '@vueuse/core'
	import QRCode from 'qrcode'

	const props = defineProps({
		redirect: {
			type: Object,
			required: true,
		},
		size: {
			type: String,
			default: 'small',
		},
	})
	const shortUrl = ref(null)
	const tinyShortUrl = computed(() =>
		shortUrl.value?.replace('https://www.asiago.it/', 'asiago.it/')
	)
	const {copy} = useClipboard()
	const inputRef = ref(null)
	const qrDataUrl = ref(null)

	if (props.redirect) {
		const shortUrlParts = []
		shortUrlParts.push('https://www.asiago.it/')
		if (props.redirect.use_prefix) {
			shortUrlParts.push('a/')
		}
		shortUrlParts.push(props.redirect.from_path.replace(/^\/+|\/+$/g, ''))
		shortUrl.value = shortUrlParts.join('')

		qrDataUrl.value = await QRCode.toDataURL(shortUrl.value + '/?source=qr')
	}
</script>
